export default __webpack_public_path__ + "static/media/element_58.8af6e9e2.avif";